import React, { useState, useContext, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import SearchIcon from '@material-ui/icons/Search'

import { HelpContext } from '../../../context'

const SearchForm = ({ type = 'default' }) => {
  const { articlesArr } = useContext(HelpContext)
  const [search, setSearch] = useState('')
  const [suggestions, setSuggestions] = useState([])
  const [showSuggestions, setShowSuggestions] = useState(false)
  const [inputFocused, setInputFocused] = useState(false)
  const history = useHistory()
  let inputTimeout = null

  // On unmount
  useEffect(() => {
    if(inputTimeout) {
      clearTimeout(inputTimeout)
    }
  }, [])

  // Input change handler
  const inputChangeHandler = (e) => {
    const value = e.target.value
    setSearch(value)
    if(value !== '') {
      let arr = []
      // Check if search term is inside article title or content
      articlesArr.forEach(article => {
        let added = false
        if(article.title['en'].toLowerCase().includes(value.trim().toLowerCase())) {
          arr.push(article)
          added = true
        }
        if(!added) {
          const blocks = article.content['en'].blocks
          for(let i = 0; i < blocks.length; i++) {
            if(blocks[i].text && blocks[i].text.toLowerCase().includes(value.trim().toLowerCase())) {
              arr.push(article)
              break
            }
          }
        }
      })
      setSuggestions(arr)
      setShowSuggestions(true)
    }else {
      setSuggestions([])
      setShowSuggestions(false)
    }
  }

  // On form submit
  const submitHandler = (e) => {
    e.preventDefault()
    if(search.trim() === '') return 

    history.push(`/help-search-results?query=${search.trim()}`)
  }

  // Suggestion click handler
  const suggestionClickHandler = (e, id) => {
    e.preventDefault()
    if(inputTimeout) {
      clearTimeout(inputTimeout)
    }
    history.push(`/help-article/${id}`)
  }

  // On input blur
  const blurClickHandler = () => {
    inputTimeout = setTimeout(() => setInputFocused(false), 500)
  }

  return (
    <form onSubmit={submitHandler} className={type === 'small' ? "help-search__form help-search__form--small" : "help-search__form"}>
      <input 
        type="text" 
        placeholder={type === 'small' ? 'Chercher' : `Recherche dans la base de connaissances`} 
        value={search} 
        onChange={inputChangeHandler} 
        onFocus={() => setInputFocused(true)}
        onBlur={blurClickHandler}
      />
      <button className="button button--primary" type="submit">{type === 'small' ? <SearchIcon /> : 'Chercher'}</button>

      {showSuggestions && inputFocused && <div className="search-suggestions">
        {suggestions.length > 0 ? 
          <ul>
            {suggestions.map((item, idx) => (
              <li key={idx}><a href="/#" onClick={(e) => suggestionClickHandler(e, item.id)}>{item.title['en']}</a></li>
            ))}
          </ul>
          :
          <p>{'Aucun résultat trouvé'}</p>
        }
      </div>}
    </form>
  )
}

export default SearchForm